import React from "react";
import { Box, CardContent, Divider, IconButton, Typography } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { CardPageItem } from "../../custom/Page";
import { FormattedMessage } from "react-intl";
import { debounce } from "../../util";

const CURRENT_YEAR = new Date().getFullYear();

const YearSelector = ({ year, setYear, message, minYear = 2019 }) => {
  const [yearLocal, setLocalYear] = React.useState(year);

  const debouncedSetYear = React.useMemo(
    () =>
      debounce((newYear) => {
        setYear(newYear);
      }, 500),
    [setYear],
  );

  const handleYear = (value) => {
    const newValue = yearLocal + value;
    setLocalYear(newValue);
    debouncedSetYear(newValue);
  };

  return (
    <CardPageItem>
      <CardContent>
        {message && (
          <Typography>
            <FormattedMessage id={message} />
          </Typography>
        )}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <IconButton
            onClick={() => handleYear(-1)}
            disabled={yearLocal <= minYear}
          >
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="h6">{yearLocal}</Typography>
          <IconButton
            onClick={() => handleYear(1)}
            disabled={yearLocal >= CURRENT_YEAR}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
        <Divider />
      </CardContent>
    </CardPageItem>
  );
};

export default YearSelector;
